export default __webpack_public_path__ + "static/media/TotemPrototype30.bc182d20.jpg";